import { useCorpSettingStore } from '@/stores'
import styles from './index.module.less'
import { cal } from '@/utils'

interface IProps {
  className?: string;
  price: number
  originPrice?: number
  discount?: number
  priceUnitName?: string
}

const Price = (props: IProps) => {
  const { price, originPrice, discount, priceUnitName } = props
  const { corpSetting } = useCorpSettingStore()
  const { currencySymbol } = corpSetting

  return (
    <div>
      <div className={ styles["price-box"] }>
        <span>{ currencySymbol }</span>
        <span className={ styles["price"] }>
          { price }
          {
            priceUnitName &&
            <span>/{ priceUnitName }</span>
          }
        </span>
      </div>
      {
        (!!originPrice || !!discount) &&
        <div className={ styles["origin-price-box"] }>
          {
            !!originPrice && originPrice != price && !!discount &&
            <span className={ styles["origin-price"] }>
              { currencySymbol }{ originPrice }
            </span>
          }
          {
            !!discount &&
            <span className={ styles["discount-box"] }>
              -{ cal.times(discount, 100) }%
            </span>
          }
        </div>
      }
    </div>
  )
}

export default Price
